import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Site } from '@debbie/common/dist/index.js';
import { isUUID } from '@debbie/common/dist/imports/data/helpers.js';
import { c, h } from '@debbie/cortex/dist/index.js';
import { selectCaseById, selectCaseLoadingStateById, } from '@debbie/cortex/dist/cases/selectors.js';
import { joinCaseWatchRoom, leaveCaseWatchRoom, } from '@debbie/cortex/dist/socket.js';
import { selectWorkflows } from '@debbie/cortex/dist/workflows/selectors.js';
import { useCreditor } from '@debbie/cortex/dist/creditors/index.js';
const CaseLoader = (props) => {
    const { id, nextId } = props;
    const site = useSelector((s) => s.site);
    const singleCase = useSelector((s) => selectCaseById(s, id));
    const singleCaseLoadingState = useSelector((s) => selectCaseLoadingStateById(s, id));
    const singleNextCase = useSelector((s) => nextId && selectCaseById(s, nextId));
    const creditorLoadable = useCreditor(singleCase?.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const workflows = useSelector(selectWorkflows);
    const shouldLoadUpdates = useSelector((s) => {
        if (singleCase == null) {
            return false;
        }
        const updates = s.caseUpdates[singleCase.caseId];
        return h.isNotLoaded(updates);
    });
    const shouldLoadCustomer = useSelector((s) => {
        if (singleCase == null) {
            return false;
        }
        const customer = s.customers[singleCase.customerId];
        return h.isNotLoaded(customer);
    });
    const shouldLoadProcedures = useSelector((s) => {
        if (singleCase == null && site === Site.Caseworker) {
            return false;
        }
        const procedures = s.procedures;
        return h.isNotLoaded(procedures);
    });
    useEffect(() => {
        if (!singleCase && !h.isLoading(singleCaseLoadingState)) {
            c.cases.getById(id, true);
        }
        // Preload next case if possible
        if (nextId) {
            if (!singleNextCase) {
                c.cases.getById(nextId, true);
            }
        }
    }, [id]);
    useEffect(() => {
        if (singleCase && !singleNextCase && nextId) {
            c.cases.getById(nextId, true);
        }
    }, [nextId, singleCase, singleNextCase]);
    // WS
    useEffect(() => {
        if (singleCase?.id) {
            const _id = `${singleCase?.id}`;
            const timestamp = Date.now();
            joinCaseWatchRoom(_id, timestamp);
            if (props.onLoadTimestamp) {
                props.onLoadTimestamp(timestamp);
            }
            return () => leaveCaseWatchRoom(_id);
        }
    }, [singleCase?.id]);
    useEffect(() => {
        if (!props.noRedirect && singleCase && isUUID(props.id)) {
            c.redirect.redirect(`/cases/${singleCase.id}`, { replace: true });
        }
    }, [singleCase]);
    useEffect(() => {
        if (singleCase && !singleCase.deleted) {
            if (shouldLoadUpdates) {
                c.cases.getUpdates(singleCase.caseId, true);
            }
            if (shouldLoadCustomer) {
                c.customers.getById(singleCase.customerId, true);
            }
            if (shouldLoadProcedures && Site.Caseworker === site) {
                c.procedures.get(true);
            }
        }
    }, [singleCase]);
    useEffect(() => {
        if (!workflows) {
            c.workflows.getAll(true);
        }
    }, []);
    return null;
};
export default CaseLoader;
//# sourceMappingURL=CaseLoader.js.map